export default {
  title: 'Impressum',
  subtitle: 'Passe die Angaben in deinem Shop-Impressum an, ohne dein Geschäftsprofil zu verändern.',
  defaultsNotice:
    'Alle Felder sind optional. Lass ein Feld leer, um weiterhin den Wert aus deinem Geschäftsprofil zu verwenden — der aktuelle Standardwert wird zur Vorschau in Grau angezeigt. Ein ausgefülltes Feld überschreibt nur das Impressum; dein Geschäftsprofil bleibt unverändert.',
  fields: {
    legal_name: {
      label: 'Firma / rechtlicher Name',
      placeholder: 'z. B. Musterbetrieb GmbH',
    },
    owner_first_name: {
      label: 'Vorname des Inhabers',
      placeholder: 'z. B. Alex',
    },
    owner_last_name: {
      label: 'Nachname des Inhabers',
      placeholder: 'z. B. Müller',
    },
    owner_email: {
      label: 'E-Mail',
      placeholder: 'z. B. info@example.com',
      invalid: 'Bitte gib eine gültige E-Mail-Adresse ein',
    },
    owner_phone_number: {
      label: 'Telefon',
      placeholder: 'z. B. +49 30 1234567',
    },
    tax_id: {
      label: 'Steuer-ID',
      placeholder: 'z. B. DE123456789',
    },
    address: {
      label: 'Adresse',
      placeholder: 'Straße, PLZ, Ort',
    },
  },
  buttons: {
    save: 'Speichern',
  },
  toasts: {
    saved: 'Impressum gespeichert',
    failed: 'Impressum konnte nicht gespeichert werden',
  },
};
